import { render } from "./GalleryGridItemLabelTags.vue?vue&type=template&id=baabce7c&scoped=true"
import script from "./GalleryGridItemLabelTags.vue?vue&type=script&lang=js"
export * from "./GalleryGridItemLabelTags.vue?vue&type=script&lang=js"

import "./GalleryGridItemLabelTags.vue?vue&type=style&index=0&id=baabce7c&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-baabce7c"]])

export default __exports__